import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Services
import Person from 'services/data/person';

// Components
import SVG from 'components/widgets/icons/svg';


export default function ClaimOption({ triageItem, claim }) {
  const triageActionComplete = !_.isEmpty(triageItem.claimedBy);
  
  return (
    <li
      onClick={triageActionComplete ? _.noop : () => claim(triageItem)}
      className={classNames('triage-option-claim', { 'triage-action-complete': triageActionComplete }, 'triage-option-header')}
    >
      <SVG src="svg/claim.svg" className="triage-option-icon claim" />
      {_.isEmpty(triageItem.claimedBy) &&
        'Claim'
      }
      {!_.isEmpty(triageItem.claimedBy) &&
        `Claimed by: ${Person.fullName(triageItem.claimedBy)}`
      }
    </li>
  );
}

ClaimOption.propTypes = {
  triageItem: PropTypes.object.isRequired,
  claim: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/claim.js